import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filterRefinementSearchFieldPlaceholder: {
		id: 'software.main.header.controls-bar.filter-refinement.search-field.placeholder',
		defaultMessage: 'Search board',
		description: 'Placeholder of filter refinement search input in boards',
	},
});
